//#region src/js/cart-items.js
var CartItems = class extends HTMLElement {
	connectedCallback() {
		this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
		this.currentItemCount = Array.from(this.querySelectorAll("[name=\"updates[]\"]")).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);
		this.addEventListener("change", this.debouncedOnChange.bind(this));
	}
	onChange(event) {
		this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
	}
	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents"
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section"
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section"
			}
		];
	}
	renderCartSections(parsedState) {
		this.getSectionsToRender().forEach((section) => {
			const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
			elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
		});
	}
	updateEmptyState(itemCount) {
		const isCartEmpty = itemCount === 0;
		const cartDrawerWrapper = document.querySelector("cart-drawer");
		const cartFooter = document.getElementById("main-cart-footer");
		this.classList.toggle("is-empty", isCartEmpty);
		cartFooter?.classList.toggle("is-empty", isCartEmpty);
		cartDrawerWrapper?.classList.toggle("is-empty", isCartEmpty);
	}
	updateQuantity(line, quantity, name) {
		this.enableLoading(line);
		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname
		});
		fetch(`${routes.cart_change_url}`, {
			...fetchConfig(),
			body
		}).then((response) => response.text()).then((state) => {
			const parsedState = JSON.parse(state);
			this.updateEmptyState(parsedState.item_count);
			this.renderCartSections(parsedState);
			this.updateLiveRegions(line, parsedState.item_count);
			this.restoreFocus(line, name, parsedState.item_count);
			this.disableLoading();
		}).catch(() => {
			const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
			errors.textContent = window.cartStrings.error;
			this.disableLoading();
		});
	}
	restoreFocus(line, name, itemCount) {
		const cartDrawerWrapper = document.querySelector("cart-drawer");
		const activeQuantityInput = (document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`))?.querySelector(`[name="${name}"]`);
		if (activeQuantityInput) {
			this.focusUpdatedLineItem(cartDrawerWrapper, activeQuantityInput);
			return;
		}
		if (itemCount === 0 && cartDrawerWrapper) {
			trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
			return;
		}
		if (document.querySelector(".cart-item") && cartDrawerWrapper) trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
	}
	focusUpdatedLineItem(cartDrawerWrapper, activeQuantityInput) {
		if (cartDrawerWrapper) {
			trapFocus(cartDrawerWrapper, activeQuantityInput);
			return;
		}
		activeQuantityInput.focus();
	}
	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
			const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-Quantity-${line}`);
			if (lineItemError && quantityElement) lineItemError.querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace("[quantity]", quantityElement.value);
		}
		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute("aria-hidden", true);
		const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);
		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1e3);
	}
	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
	}
	enableLoading(line) {
		(document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.add("cart__items--disabled");
		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove("hidden"));
		document.activeElement?.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}
	disableLoading() {
		(document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.remove("cart__items--disabled");
	}
};
customElements.define("cart-items", CartItems);
//#endregion
